import React, { ReactNode } from 'react';
import { Text } from '@itandi/itandi-bb-ui';
import Styles from '../list/ConstructionList.module.scss';
import {
  DealConstruction,
  getConstructionItemName,
  getUnitText
} from '~/models/DealConstruction';
import { ConstructionListFooterRow } from '../list/ConstructionListFooterRow';
import { FeeRow } from '../list/FeeRow';
import { ConstructionAmountRow } from '../list/ConstructionAmountRow';
import { toThousandSeparator } from '~/utils/CurrencySeparator';
import { DealEstimationHistoryContext } from '~/models/DealEstimationHistory';
import { isEmpty } from '~/utils/StringUtil';

type Props = {
  constructionContext: DealEstimationHistoryContext;
  companyType: 'client' | 'vendor' | 'partner';
};

export const ConstructionListRow: React.FC<Props> = ({
  constructionContext,
  companyType
}: Props) => {
  const { dealConstructions } = constructionContext;
  const renderRow = (dealConstruction: DealConstruction): ReactNode => (
    <tr key={dealConstruction.id} className={Styles.ListRow}>
      <td className={Styles.OrderHandle} />
      <td className={Styles.Estimation}>
        <div className={Styles.EstimationConfirmedPointAndItem}>
          {!isEmpty(dealConstruction.point) && (
            <div className={Styles.Point}>{dealConstruction.point}</div>
          )}
          {getConstructionItemName(dealConstruction)}
        </div>
        {!isEmpty(dealConstruction.note) && (
          <Text marginTop=".25rem" size="XS">
            備考）{dealConstruction.note}
          </Text>
        )}
      </td>
      <td className={Styles.UnitAmount}>
        <p>
          ¥{toThousandSeparator(dealConstruction.unitAmount)} *{' '}
          {toThousandSeparator(dealConstruction.unit)}
          {getUnitText(dealConstruction)}
        </p>
      </td>
      <td className={Styles.ChargePer}>
        <p>
          借主{dealConstruction.renteeChargeWithPercentage} : 貸主
          {dealConstruction.ownerChargeWithPercentage} : 管理
          {dealConstruction.companyChargeWithPercentage}
        </p>
      </td>
      <td className={Styles.Amount}>
        <p>¥{toThousandSeparator(dealConstruction.totalAmount)}</p>
      </td>
    </tr>
  );
  return (
    <>
      {dealConstructions.map(renderRow)}
      {dealConstructions.length > 0 &&
        constructionContext.managementFee !== 0 && (
          <FeeRow
            fee={constructionContext.managementFee}
            feeTitle="諸経費（工事管理費）"
            showSwitchEnable={false}
          />
        )}
      {companyType === 'vendor' && constructionContext.vendorFee !== 0 && (
        <ConstructionAmountRow constructionContext={constructionContext} />
      )}
      {dealConstructions.length > 0 &&
        companyType !== 'client' &&
        constructionContext.vendorFee !== 0 && (
          <FeeRow
            fee={constructionContext.vendorFee}
            feeTitle="送客手数料（管理会社には表示されません）"
            showSwitchEnable={false}
          />
        )}
      <ConstructionListFooterRow
        companyType={companyType}
        constructionContext={constructionContext}
        docType="estimation"
        showButtons={false}
        showSwitchEnable={false}
        target={null}
      />
    </>
  );
};
